const copyToClipBoard = (text) => navigator.clipboard?.writeText(text).then();

export default copyToClipBoard;
